import {inject, Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ArbitraryEmailDto, PointEmailDto} from "../../generated-model/model";
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";

@Injectable({providedIn: "root"})
export class PointEmailResource {
  http = inject(HttpClient)

  public findAllEmail(): Observable<PointEmailDto[]> {
    return this.http.get<PointEmailDto[]>(`${environment.serverUrl}/api/point-email`);
  }

  save(item: PointEmailDto) {
    return this.http.post(`${environment.serverUrl}/api/point-email`, item);
  }

  update(groupEmail: string) {
    return this.http.post(`${environment.serverUrl}/api/point-email/change-group`, null, {
      params: { groupEmail }
    });
  }
}
